import { TEXTS } from '../../constants';
import { parsePipeList } from '../../utils';
import {
  SectionWrapper,
  ContentContainer,
  SectionHeading,
  CredentialsGrid,
  CredentialCard,
  LanguagesCard,
  CardTitle,
  ListContainer,
  ListItem,
  ListBullet,
  ListText,
  LanguagesContainer,
  LanguageChip,
  NoDataText,
} from './styles';

const CredentialList = ({ title, items }) => {
  const parsedItems = parsePipeList(items);
  if (!parsedItems.length) return null;

  return (
    <CredentialCard>
      <CardTitle>{title}</CardTitle>
      <ListContainer>
        {parsedItems.map((item, idx) => (
          <ListItem key={idx}>
            <ListBullet />
            <ListText>{item}</ListText>
          </ListItem>
        ))}
      </ListContainer>
    </CredentialCard>
  );
};

const LanguagesList = ({ languages }) => {
  const parsedLanguages = parsePipeList(languages);
  if (!parsedLanguages.length) return null;

  return (
    <LanguagesCard>
      <CardTitle>{TEXTS.credentials.languages}</CardTitle>
      <LanguagesContainer>
        {parsedLanguages.map((language, idx) => (
          <LanguageChip key={idx} label={language} />
        ))}
      </LanguagesContainer>
    </LanguagesCard>
  );
};

const CredentialsSection = ({ practitionerData }) => {
  const { education, certifications, memberships, practitionerTypes, languages } = practitionerData;

  const hasCredentials =
    education || certifications || memberships || practitionerTypes || languages;

  return (
    <SectionWrapper>
      <ContentContainer>
        <SectionHeading>{TEXTS.credentials.title}</SectionHeading>

        <CredentialsGrid>
          <CredentialList title={TEXTS.credentials.education} items={education} />
          <CredentialList title={TEXTS.credentials.certifications} items={certifications} />
          <CredentialList title={TEXTS.credentials.memberships} items={memberships} />
          <CredentialList title={TEXTS.credentials.practitionerTypes} items={practitionerTypes} />
          <LanguagesList languages={languages} />
        </CredentialsGrid>

        {!hasCredentials && <NoDataText>{TEXTS.credentials.noData}</NoDataText>}
      </ContentContainer>
    </SectionWrapper>
  );
};

export default CredentialsSection;
